// persist → persisted → persist, como no leitor-jwpub. Sem persistência o iOS
// pode evictar o IndexedDB; o valor de persisted() aparece em Ajustes.
export async function garantirPersistencia(
  storage: StorageManager | undefined = globalThis.navigator?.storage,
): Promise<boolean> {
  try {
    if (!storage || typeof storage.persist !== 'function') return false;
    if (await storage.persisted()) return true;
    return await storage.persist();
  } catch {
    return false;
  }
}

export async function estimativa(
  storage: StorageManager | undefined = globalThis.navigator?.storage,
): Promise<{ usado: number; cota: number; persistido: boolean } | null> {
  try {
    if (!storage || typeof storage.estimate !== 'function') return null;
    const [e, persistido] = await Promise.all([
      storage.estimate(),
      storage.persisted(),
    ]);
    return { usado: e.usage ?? 0, cota: e.quota ?? 0, persistido };
  } catch {
    return null;
  }
}
